import RouterUtil from '@/utils/RouterUtil';
import { useRoute } from 'vue-router';
import WechatApi from '@/api/wechat-api';
import SessionUtil from '@/utils/SessionUtil';
import { showDialog } from 'vant';
import StorageUtil from '@/utils/StorageUtil';
import OrderApi from '@/api/order-api';
import UserApi from '@/api/user-api';
export default {
  name: 'WeChatLogin',
  data() {
    return {};
  },
  mounted() {
    this.goto();
  },
  activated() {
    this.goto();
  },
  methods: {
    goto() {
      const route = useRoute();
      if (route.query.code) {
        WechatApi.wxLogin(route.query.code).then(async rs => {
          var _rs$response;
          if (((_rs$response = rs.response) === null || _rs$response === void 0 || (_rs$response = _rs$response.data) === null || _rs$response === void 0 ? void 0 : _rs$response.code) === 400023) {
            showDialog({
              closeOnPopstate: false,
              title: '乘客微信未绑定',
              message: '[Err:S400023] 微信未绑定乘客信息，请先进行乘客微信绑定',
              confirmButtonText: '绑定微信',
              showCancelButton: true
            }).then(() => {
              window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9865cc9a8b41fdbc&redirect_uri=https%3A%2F%2Fbiz.wx.dishida.net%2Fbind&response_type=code&scope=snsapi_userinfo&state=state#wechat_redirect';
            }).catch(() => {
              showDialog({
                closeOnPopstate: false,
                message: '请关闭或回退当前页面',
                showConfirmButton: false
              });
            });
            return;
          }
          if (rs.success) {
            var _rs$data, _rs$data2;
            if ((_rs$data = rs.data) !== null && _rs$data !== void 0 && _rs$data.token && ((_rs$data2 = rs.data) === null || _rs$data2 === void 0 || (_rs$data2 = _rs$data2.token) === null || _rs$data2 === void 0 ? void 0 : _rs$data2.length) > 0) {
              SessionUtil.setUserToken(rs.data.token);
              StorageUtil.set('weChatModel', true);
              await UserApi.getUserInfo();
              setTimeout(function () {
                if (RouterUtil.containsQuery(route, 'index')) {
                  RouterUtil.go('/index');
                  return;
                }
                if (RouterUtil.containsQuery(route, 'calling')) {
                  OrderApi.getWaitDispatchOrder().then(function (result) {
                    if (result.success) {
                      StorageUtil.setObject('orderInitiateData', {
                        startAddress: result.orderData.departure_address,
                        startPosition: [result.orderData.departure_address_longitude, result.orderData.departure_address_latitude],
                        endAddress: result.orderData.destination_address,
                        endPosition: [result.orderData.destination_address_longitude, result.orderData.destination_address_latitude]
                      });
                      RouterUtil.go('/order/calling');
                    } else {
                      OrderApi.getProgressOrder().then(function (result) {
                        if (result.success) {
                          StorageUtil.setObject('orderInitiateData', {
                            startAddress: result.orderData.departure_address,
                            startPosition: [result.orderData.departure_address_longitude, result.orderData.departure_address_latitude],
                            endAddress: result.orderData.destination_address,
                            endPosition: [result.orderData.destination_address_longitude, result.orderData.destination_address_latitude]
                          });
                          StorageUtil.setObject('orderData', result.orderData);
                          RouterUtil.go('/order/progress');
                        } else {
                          RouterUtil.go('/open/order-invalid');
                        }
                      }).catch(() => {
                        RouterUtil.go('/open/order-invalid');
                      });
                    }
                  }).catch(() => {
                    RouterUtil.go('/open/order-invalid');
                  });
                }
              }, 500);
            } else {
              showDialog({
                closeOnPopstate: false,
                title: '业务信息异常',
                message: '[Err:404001001] 查询微信用户失败，请通过原始链接重新访问页面',
                showConfirmButton: false
              });
            }
          } else {
            showDialog({
              closeOnPopstate: false,
              title: '业务信息异常',
              message: '[Err:404001000] 查询微信用户失败，请通过原始链接重新访问页面',
              showConfirmButton: false
            });
          }
        }).catch(() => {
          showDialog({
            closeOnPopstate: false,
            title: '业务信息异常',
            message: '[Err:404001002] 查询微信用户失败，请通过原始链接重新访问页面',
            showConfirmButton: false
          });
        });
      } else {
        showDialog({
          closeOnPopstate: false,
          title: '不支持的访问方式',
          message: '[Err:404001000] 业务信息异常，访问方式不受支持，请正确打开当前页面',
          showConfirmButton: false
        });
      }
    }
  }
};